import React, { FC } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { NSKeys } from '@app/i18n';

import { useGetWarehouseCustomersQuery } from '../../../../hooks';

export const CreateWarehouseButton: FC = () => {
  const navigate = useNavigate();
  const warehousesT = useTranslation(NSKeys.warehouses);
  const { data: customers = [], isInitialLoading } = useGetWarehouseCustomersQuery();

  let disabledReason: string | undefined;
  if (!isInitialLoading && !customers.length) {
    disabledReason = warehousesT.t('noWarehouseCustomers');
  }

  return (
    <Tooltip title={disabledReason}>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => navigate('add')}
        size="middle"
        loading={isInitialLoading}
        disabled={!!disabledReason}
      >
        {warehousesT.t('addButton')}
      </Button>
    </Tooltip>
  );
};
